export enum UserInfo {
	UserId = 'userId',
	TenantId = 'tenantId',
	SupplierId = 'supplierId',
}
